export const SET_LOGGEDIN = 'SET_LOGGEDIN';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
export const SET_ORG_ID = 'SET_ORG_ID'